import { useEffect, useState, useCallback } from "react";
import {
    useNavigate,
    useParams,
    useLocation
} from "react-router-dom";

import API from "../../api/api";

export default function TourDetails() {

    const { id } = useParams();

    const navigate = useNavigate();
const location = useLocation();

const isAdmin =
    location.pathname.startsWith("/admin");
    const [tour, setTour] = useState(null);
    const [guests, setGuests] = useState([]);
    const [tickets, setTickets] = useState([]);
    const [adminNotes, setAdminNotes] = useState("");
const [guideNotes, setGuideNotes] = useState("");

const [uploading, setUploading] = useState(false);

const [selectedFile, setSelectedFile] = useState(null);
    const [loading, setLoading] = useState(true);

    

    const load = useCallback(async () => {

    try {

        setLoading(true);

        const sessionRes =
            await API.get(
                isAdmin
                    ? `/admin/tour-sessions/${id}`
                    : `/coordinator/tour-sessions/${id}`
            );

        console.log("Tour session:", sessionRes.data);
        setTour(sessionRes.data);

        try {
            const detailRes =
                await API.get(
                    isAdmin
                        ? `/admin/guides/tour-sessions/${id}/details`
                        : `/coordinator/tour-sessions/${id}/details`
                );

            console.log("Detail response:", detailRes.data);

            setGuests(
                detailRes.data.guests || []
            );

        } catch (err) {
            console.error("Unable to load tour guests:", err);
            setGuests([]);
        }

        try {
            const ticketRes = await API.get(
                isAdmin
                    ? `/admin/guides/tour-sessions/${id}/tickets`
                    : `/coordinator/tour-sessions/${id}/tickets`
            );

            setTickets(ticketRes.data || []);

        } catch (err) {
            console.error("Unable to load tour tickets:", err);
            setTickets([]);
        }

const notesRes = await API.get(

    isAdmin

        ? `/admin/guides/tour-sessions/${id}/notes`

        : `/guide/tour-sessions/${id}/notes`

);

setAdminNotes(
    notesRes.data.admin_notes || ""
);

setGuideNotes(
    notesRes.data.guide_notes || ""
);

        } catch (err) {

            console.error(err);

        } finally {

            setLoading(false);

        }

    }, [id, isAdmin]);

    useEffect(() => {

        load();

    }, [load]);

    const uploadTicket = async () => {

    if (!selectedFile) return;

    const formData = new FormData();

    formData.append(
        "ticket",
        selectedFile
    );

    setUploading(true);

    try {

        await API.post(

            `/admin/guides/tour-sessions/${id}/ticket`,

            formData,

            {
                headers: {
                    "Content-Type":
                        "multipart/form-data"
                }
            }

        );

        setSelectedFile(null);

        load();

    }

    finally {

        setUploading(false);

    }

};

const saveNotes = async () => {

    try {

        await API.put(

    isAdmin

        ? `/admin/guides/tour-sessions/${id}/notes`

        : `/guide/tour-sessions/${id}/notes`,

    {

        admin_notes: adminNotes,

        guide_notes: guideNotes

    }

);

        alert("Notes saved");

    } catch (err) {

        console.error(err);

        alert("Unable to save notes");

    }

};

const openTicket = async (ticketId) => {

    const res = await API.get(
    isAdmin
        ? `/admin/guides/tickets/${ticketId}`
        : `/coordinator/tickets/${ticketId}`,

    {
        responseType: "blob"
    }
);

    const url = window.URL.createObjectURL(res.data);

    window.open(url, "_blank");

};

const downloadTicket = async (ticketId) => {

    const res = await API.get(

       isAdmin
    ? `/admin/guides/tickets/${ticketId}`
    : `/coordinator/tickets/${ticketId}`,

        {
            responseType: "blob"
        }

    );

    const url = window.URL.createObjectURL(res.data);

    const a = document.createElement("a");

    a.href = url;

    a.download = "ticket.pdf";

    a.click();

};
const deleteTicket = async (ticketId) => {

    if (

        !window.confirm(

            "Delete this ticket?"

        )

    ) return;

    await API.delete(

        `/admin/guides/tickets/${ticketId}`

    );

    load();

};

    if (loading) {

        return (

            <div style={loadingStyle}>

                Loading...

            </div>

        );

    }

    if (!tour) {

        return (

            <div style={loadingStyle}>

                Tour not found

            </div>

        );

    }

   const stats = guests.reduce(
    (acc, g) => {

        acc.total += Number(g.total_guests);

        acc.adults += Number(g.adults);

        acc.children += Number(g.children);

        acc.youth += Number(g.youth);

        acc.infants += Number(g.infants);

        return acc;

    },
    {
        total: 0,
        adults: 0,
        children: 0,
        youth: 0,
        infants: 0
    }
);

    return (

        <div style={page}>

            <button
                onClick={() => {

    if (isAdmin) {

        navigate("/admin/tours");

    } else {

        navigate(-1);

    }

}}
                style={backButton}
            >

                ← Back

            </button>

          <div style={heroCard}>

    <div style={heroTop}>

        <div>

            <div style={tourLabel}>

                TOUR SESSION

            </div>

            <h1 style={{heroTitle,fontSize: window.innerWidth < 768 ? 28 : 42}}>

                {tour.title}

            </h1>

            <div style={heroDate}>

                {new Date(
                    tour.start_datetime
                ).toLocaleDateString(
                    "en-GB",
                    {
                        weekday: "long",
                        day: "numeric",
                        month: "long",
                        year: "numeric"
                    }
                )}

            </div>

            <div style={heroTime}>

                🕒{" "}

                {new Date(
                    tour.start_datetime
                ).toLocaleTimeString([],{
                    hour:"2-digit",
                    minute:"2-digit"
                })}

                {"  —  "}

                {new Date(
                    tour.end_datetime
                ).toLocaleTimeString([],{
                    hour:"2-digit",
                    minute:"2-digit"
                })}

            </div>

        </div>

        <div style={heroStatus}>

            <div style={capacityCircle}>

                <strong>

                    {tour.booked}

                </strong>

                <span>

                    / {tour.capacity}

                </span>

            </div>

            <div style={capacityText}>

                Guests

            </div>

        </div>

    </div>

    <div style={heroBottom}>

        <div style={infoChip}>

            👥 {tour.booked} Guests

        </div>

        <div style={infoChip}>

            🗣 {tour.languages || "No language"}

        </div>

        <div style={infoChip}>

            {isAdmin

                ? "🧑‍💼 Admin"

               : "🧑‍💼 Coordinator"}

        </div>

    </div>

</div>

         <div style={statsGrid}>

    <div style={statCard}>

        <div style={statIcon}>
            👥
        </div>

        <div>

            <div style={statValue}>

                {stats.total}

            </div>

            <div style={statLabel}>

                Total Guests

            </div>

        </div>

    </div>

    <div style={statCard}>

        <div style={statIcon}>
            👨
        </div>

        <div>

            <div style={statValue}>

                {stats.adults}

            </div>

            <div style={statLabel}>

                Adults

            </div>

        </div>

    </div>

    <div style={statCard}>

        <div style={statIcon}>
            🧑
        </div>

        <div>

            <div style={statValue}>

                {stats.youth}

            </div>

            <div style={statLabel}>

                Youth

            </div>

        </div>

    </div>

    <div style={statCard}>

        <div style={statIcon}>
            🧒
        </div>

        <div>

            <div style={statValue}>

                {stats.children}

            </div>

            <div style={statLabel}>

                Children

            </div>

        </div>

    </div>

    <div style={statCard}>

        <div style={statIcon}>
            👶
        </div>

        <div>

            <div style={statValue}>

                {stats.infants}

            </div>

            <div style={statLabel}>

                Infants

            </div>

        </div>

    </div>

</div>

            <div style={section}>

    <div style={sectionHeader}>

        <div>

            <div style={sectionEyebrow}>

                NOTES

            </div>

            <h2 style={sectionTitle}>

                Tour Communication

            </h2>

            <div style={sectionSubtitle}>

                Information shared between the office and the coordinator.

            </div>

        </div>

        <button
            style={saveButton}
            onClick={saveNotes}
        >

            💾 Save Notes

        </button>

    </div>

    <div style={notesCards}>

        <div style={noteCard}>

            <div style={noteHeader}>

                <span style={noteIcon}>

                    🧑‍💼

                </span>

                <div>

                    <strong>

                        Admin Notes

                    </strong>

                    <div style={noteDescription}>

                        Visible to the assigned coordinator.

                    </div>

                </div>

            </div>

            <textarea

                value={adminNotes}

                onChange={e =>
                    setAdminNotes(
                        e.target.value
                    )
                }

                readOnly={!isAdmin}

                style={noteTextarea}

                placeholder="Meeting point, special requests, VIP guests, timing changes..."

            />

        </div>

        <div style={noteCard}>

            <div style={noteHeader}>

                <span style={noteIcon}>

                    🧧

                </span>

                <div>

                    <strong>

                        Coordinator Report

                    </strong>

                    <div style={noteDescription}>

                        Tour coordination notes and incidents.

                    </div>

                </div>

            </div>

            <textarea

                value={guideNotes}

                onChange={e =>
                    setGuideNotes(
                        e.target.value
                    )
                }

                readOnly={isAdmin}

                style={noteTextarea}

                placeholder="How did the tour go? Any issues? Missing guests? Delays?"

            />

        </div>

    </div>

</div>


           <div style={section}>

    <div style={sectionHeader}>

        <div>

            <div style={sectionEyebrow}>

                DOCUMENTS

            </div>

            <h2 style={sectionTitle}>

                Tour Tickets

            </h2>

            <div style={sectionSubtitle}>

                Museum tickets and supporting documents.

            </div>

        </div>

    </div>

    {

        isAdmin && (

            <div style={uploadCard}>

                <div>

                    <strong>

                        Upload Ticket

                    </strong>

                    <div style={uploadSubtitle}>

                        PDF, JPG or PNG

                    </div>

                </div>

                <div style={uploadControls}>

                    <input

                        type="file"

                        accept=".pdf,.jpg,.jpeg,.png"

                        onChange={e =>
                            setSelectedFile(
                                e.target.files[0]
                            )
                        }

                    />

                    <button

                        style={uploadButton}

                        disabled={
                            !selectedFile ||
                            uploading
                        }

                        onClick={uploadTicket}

                    >

                        {

                            uploading

                                ? "Uploading..."

                                : "Upload"

                        }

                    </button>

                </div>

            </div>

        )

    }

    {

        tickets.length === 0

            ?

            <div style={emptyTicket}>

                📄

                <h3>

                    No Tickets Uploaded

                </h3>

                <p>

                    Upload museum tickets here so guides can access them before the tour.

                </p>

            </div>

            :

            <div style={ticketGrid}>

                {

                    tickets.map(ticket => (

                        <div
                            key={ticket.id}
                            style={ticketCard}
                        >

                            <div style={ticketIcon}>

                                📄

                            </div>

                            <div style={{flex:1}}>

                                <strong>

                                    Tour Ticket

                                </strong>

                                <div style={ticketMeta}>

                                    Uploaded

                                </div>

                            </div>

                            <div style={ticketActions}>

                                <button

                                    style={smallAction}

                                    onClick={() =>
                                        openTicket(ticket.id)
                                    }

                                >

                                    👁

                                </button>

                                <button

                                    style={smallAction}

                                    onClick={() =>
                                        downloadTicket(ticket.id)
                                    }

                                >

                                    ⬇

                                </button>

                                {

                                    isAdmin && (

                                        <button

                                            style={deleteAction}

                                            onClick={() =>
                                                deleteTicket(ticket.id)
                                            }

                                        >

                                            🗑

                                        </button>

                                    )

                                }

                            </div>

                                                    </div>

                       

                    ))

                }

            </div>

    }

</div>

<div style={section}>

    <div style={sectionHeader}>

        <div>

            <div style={sectionEyebrow}>

                BOOKINGS

            </div>

            <h2 style={sectionTitle}>

                Guest List

            </h2>

            <div style={sectionSubtitle}>

                {guests.length} booking{guests.length !== 1 ? "s" : ""} for this tour.

            </div>

        </div>

    </div>

    {

        guests.length === 0

            ?

            <div style={emptyGuests}>

                <div style={emptyGuestsIcon}>

                    👥

                </div>

                <h3>

                    No Guests Yet

                </h3>

                <p>

                    As soon as someone books this tour they will appear here.

                </p>

            </div>

            :

            guests.map(g => (

                <div

                    key={g.booking_id}

                    style={guestCardNew}

                >

                    <div style={guestTop}>

                        <div style={guestAvatar}>

                            {g.first_name?.charAt(0)}

                            {g.last_name?.charAt(0)}

                        </div>

                        <div style={{flex:1}}>

                            <h3 style={guestTitle}>

                                {g.first_name} {g.last_name}

                            </h3>

                            <div style={guestBookingInfo}>

                                Booking #{g.booking_id}

                            </div>

                        </div>

                        <div style={bookingBadge}>

                            👥 {g.total_guests}

                        </div>

                    </div>

                    <div style={passengerRow}>

                        {

                            Number(g.adults) > 0 && (

                                <span style={passengerChip}>

                                    👨 {g.adults} Adults

                                </span>

                            )

                        }

                        {

                            Number(g.youth) > 0 && (

                                <span style={passengerChip}>

                                    🧑 {g.youth} Youth

                                </span>

                            )

                        }

                        {

                            Number(g.children) > 0 && (

                                <span style={passengerChip}>

                                    🧒 {g.children} Children

                                </span>

                            )

                        }

                        {

                            Number(g.infants) > 0 && (

                                <span style={passengerChip}>

                                    👶 {g.infants} Infants

                                </span>

                            )

                        }

                    </div>

                    <div style={contactRow}>

                    

    <div>

        📞 {g.phone || "-"}

    </div>

</div>

                </div>

            ))

    }

</div>

                 

        </div>

    );

}

const page = {
  padding: 18,
  background: "#F8FAFC",
  minHeight: "100vh",
  width: "100%",
  maxWidth: "100%",
  boxSizing: "border-box",
  overflowX: "hidden"
};

const loadingStyle = {

    padding: 40,

    textAlign: "center"

};

const backButton = {

    border: "none",

    background: "none",

    fontSize: 16,

    fontWeight: 700,

    marginBottom: 20,

    cursor: "pointer"

};

 

const section = {

    background: "white",

    borderRadius: 18,

    padding: 20,

    marginBottom: 18,

    boxShadow: "0 6px 18px rgba(0,0,0,.08)"

};


const heroCard = {

    background: "linear-gradient(135deg,#EA580C,#F97316)",

    color: "white",

    borderRadius: 24,

    padding: 28,

    marginBottom: 22,

    boxShadow: "0 18px 40px rgba(249,115,22,.28)"

};

const heroTop = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    gap: 20,
    flexWrap: "wrap"
};

const heroBottom = {
    display: "flex",
    gap: 10,
    flexWrap: "wrap",
    marginTop: 20
};

const heroTitle = {

    margin: "8px 0",

    fontSize: 34,

    fontWeight: 800

};

const heroDate = {

    opacity: .95,

    fontSize: 18,

    marginBottom: 6

};

const heroTime = {

    opacity: .9,

    fontSize: 16

};

const tourLabel = {

    fontSize: 12,

    letterSpacing: 2,

    fontWeight: 700,

    opacity: .8

};

const heroStatus = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 110
};

const capacityCircle = {

    width: 110,

    height: 110,

    borderRadius: "50%",

    background: "rgba(255,255,255,.15)",

    display: "flex",

    flexDirection: "column",

    justifyContent: "center",

    alignItems: "center",

    fontSize: 32,

    fontWeight: 800,

    border: "3px solid rgba(255,255,255,.25)"

};

const capacityText = {

    marginTop: 10,

    fontWeight: 700

};

const infoChip = {
    padding: "8px 14px",
    background: "rgba(255,255,255,.15)",
    borderRadius: 999,
    fontWeight: 600,
    fontSize: 13
};

const statsGrid = {
    display: "grid",
    gridTemplateColumns:
        window.innerWidth < 768
            ? "repeat(2,1fr)"
            : "repeat(auto-fit,minmax(180px,1fr))",
    gap: 14,
    marginBottom: 22
};

const statCard = {

    background: "white",

    borderRadius: 18,

    padding: 20,

    display: "flex",

    alignItems: "center",

    gap: 18,

    boxShadow: "0 10px 25px rgba(15,23,42,.08)"

};

const statIcon = {

    width: 56,

    height: 56,

    borderRadius: 16,

    background: "#FFF7ED",

    color: "#EA580C",

    display: "flex",

    justifyContent: "center",

    alignItems: "center",

    fontSize: 26

};

const statValue = {

    fontSize: 28,

    fontWeight: 800,

    lineHeight: 1

};

const statLabel = {

    color: "#64748B",

    marginTop: 4,

    fontWeight: 600

};

const sectionHeader = {

    display: "flex",

    justifyContent: "space-between",

    alignItems: "center",

    marginBottom: 24,

    gap: 20,

    flexWrap: "wrap"

};

const sectionEyebrow = {

    color: "#F97316",

    fontSize: 12,

    fontWeight: 700,

    letterSpacing: 2,

    marginBottom: 6

};

const sectionTitle = {

    margin: 0,

    fontSize: 28,

    fontWeight: 800,

    color: "#0F172A"

};

const sectionSubtitle = {

    marginTop: 6,

    color: "#64748B"

};

const saveButton = {

    padding: "14px 26px",

    background: "#F97316",

    color: "white",

    border: "none",

    borderRadius: 14,

    cursor: "pointer",

    fontWeight: 700,

    fontSize: 15,

    boxShadow: "0 8px 18px rgba(249,115,22,.25)"

};

const notesCards = {
  display: "grid",
  gridTemplateColumns: "1fr",
  gap: 16,
  width: "100%",
  maxWidth: "100%",
  boxSizing: "border-box"
};

const noteCard = {
  background: "#F8FAFC",
  borderRadius: 20,
  padding: 22,
  border: "1px solid #E2E8F0",
  width: "100%",
  maxWidth: "100%",
  minWidth: 0,
  boxSizing: "border-box"
};

const noteHeader = {

    display: "flex",

    gap: 16,

    alignItems: "center",

    marginBottom: 18

};

const noteIcon = {

    width: 48,

    height: 48,

    display: "flex",

    justifyContent: "center",

    alignItems: "center",

    borderRadius: 14,

    background: "#FFF7ED",

    fontSize: 24

};

const noteDescription = {

    color: "#64748B",

    marginTop: 4,

    fontSize: 13

};

const noteTextarea = {
  width: "100%",
  maxWidth: "100%",
  minWidth: 0,
  minHeight: 220,
  borderRadius: 16,
  border: "1px solid #CBD5E1",
  background: "white",
  padding: 18,
  fontSize: 15,
  resize: "vertical",
  lineHeight: 1.6,
  fontFamily: "inherit",
  boxSizing: "border-box",
  display: "block"
};

const uploadCard={

    display:"flex",

    justifyContent:"space-between",

    alignItems:"center",

    gap:20,

    flexWrap:"wrap",

    background:"#FFF7ED",

    border:"2px dashed #FDBA74",

    borderRadius:18,

    padding:22,

    marginBottom:24

};

const uploadSubtitle={

    color:"#64748B",

    marginTop:6

};

const uploadControls={

    display:"flex",

    gap:12,

    alignItems:"center",

    flexWrap:"wrap"

};

const uploadButton={

    padding:"12px 22px",

    background:"#EA580C",

    color:"white",

    border:"none",

    borderRadius:12,

    cursor:"pointer",

    fontWeight:700

};

const ticketGrid={

    display:"grid",

    gap:18

};

const ticketCard={

    display:"flex",

    alignItems:"center",

    gap:18,

    background:"white",

    borderRadius:18,

    padding:18,

    border:"1px solid #E2E8F0",

    boxShadow:"0 6px 18px rgba(0,0,0,.06)"

};

const ticketIcon={

    width:62,

    height:62,

    borderRadius:18,

    background:"#FFF7ED",

    display:"flex",

    justifyContent:"center",

    alignItems:"center",

    fontSize:28

};

const ticketMeta={

    color:"#64748B",

    marginTop:4,

    fontSize:13

};

const ticketActions={

    display:"flex",

    gap:10

};

const smallAction={

    width:44,

    height:44,

    borderRadius:12,

    border:"none",

    background:"#F1F5F9",

    cursor:"pointer",

    fontSize:18

};

const deleteAction={

    width:44,

    height:44,

    borderRadius:12,

    border:"none",

    background:"#FEE2E2",

    color:"#DC2626",

    cursor:"pointer",

    fontSize:18

};

const emptyTicket={

    textAlign:"center",

    padding:"60px 20px",

    color:"#64748B",

    border:"2px dashed #CBD5E1",

    borderRadius:18

};

const guestCardNew={

    background:"white",

    borderRadius:22,

    padding:24,

    marginBottom:18,

    boxShadow:"0 12px 28px rgba(15,23,42,.08)",

    border:"1px solid #EEF2F7"

};

const guestTop = {
    display:"flex",
    alignItems:
        window.innerWidth < 768
            ? "flex-start"
            : "center",
    flexDirection:
        window.innerWidth < 768
            ? "column"
            : "row",
    gap:18,
    marginBottom:20
};

const guestAvatar={

    width:64,

    height:64,

    borderRadius:"50%",

    background:"linear-gradient(135deg,#EA580C,#FB923C)",

    color:"white",

    display:"flex",

    justifyContent:"center",

    alignItems:"center",

    fontSize:22,

    fontWeight:700

};

const guestTitle={

    margin:0,

    fontSize:22,

    fontWeight:700,

    color:"#0F172A"

};

const guestBookingInfo={

    color:"#64748B",

    marginTop:4

};

const bookingBadge={

    background:"#FFF7ED",

    color:"#EA580C",

    padding:"10px 18px",

    borderRadius:999,

    fontWeight:700,

    fontSize:15

};

const passengerRow = {
    display:"flex",
    flexWrap:"wrap",
    gap:8,
    marginBottom:18
};

const passengerChip={

    background:"#F8FAFC",

    padding:"10px 16px",

    borderRadius:999,

    border:"1px solid #E2E8F0",

    fontWeight:600

};

const contactRow={

    display:"flex",

    gap:16,

    marginTop:10

};



const emptyGuests={

    textAlign:"center",

    padding:"70px 20px",

    color:"#64748B"

};

const emptyGuestsIcon={

    fontSize:70,

    marginBottom:20

};